import { render } from "./ClassListCard.vue?vue&type=template&id=251491ea&scoped=true"
import script from "./ClassListCard.vue?vue&type=script&lang=js"
export * from "./ClassListCard.vue?vue&type=script&lang=js"

import "./ClassListCard.vue?vue&type=style&index=0&id=251491ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251491ea"]])

export default __exports__